import React from 'react';
import styles from './StepContainer.module.css';
import { StepWrapperProps } from './types';
import { TRANSLATION_PERCENTAGE } from '../../../constants/progressBanner';

export const StepWrapper = ({ currentStep, children }: StepWrapperProps) => {
    return (
        <div className={styles.formContainer}>
            <div
                className={styles.formWrapper}
                style={{
                    transform: `translateX(-${currentStep * TRANSLATION_PERCENTAGE}%)`,
                }}
            >
                {children}
            </div>
        </div>
    );
};
